import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { CtaBand } from "../components/ui/CtaBand";
import { PlaceholderTag } from "../components/ui/PlaceholderTag";
import { WorkCard } from "../components/work/WorkCard";
import { PROJECTS, WORK_FILTERS } from "../data/work";
type Filter = (typeof WORK_FILTERS)[number];
export function Work() {
  const [filter, setFilter] = useState<Filter>("All");
  useSeo({
    title: "Work",
    description: "Website projects by NEXORA Web Studio across small business, restaurant, automotive, contractor, e-commerce and personal brand.",
    path: "/work"
  });
  const visible = filter === "All" ? PROJECTS : PROJECTS.filter(p => p.category === filter);
  return <>
      <PageHero crumbs={[{
      label: "Work"
    }]} eyebrow="Work" title="Websites built for real businesses." lead="Case studies will be added as client projects are approved for sharing. Until then, every card below is a clearly marked placeholder." aside={<PlaceholderTag data-id="element-972" data-mp="3e9l1dds9sgim">Placeholder projects — real work coming soon</PlaceholderTag>} data-id="element-971" data-mp="eosixaofn4gt" />
      <section className="shell section" data-id="element-973" data-mp="3s06l14pjsuhk">
        <div role="group" aria-label="Filter by category" className="-mx-1 mb-10 flex gap-2 overflow-x-auto px-1 pb-2" data-id="element-974" data-mp="3s19974vhkits">
          {WORK_FILTERS.map(f => <button key={f} type="button" aria-pressed={filter === f} onClick={() => setFilter(f)} className={`min-h-[44px] shrink-0 whitespace-nowrap rounded-full border px-5 text-[15px] transition-colors duration-150 ease-out ${filter === f ? "border-fg bg-fg text-ink" : "border-line-strong text-fg-2 hover:border-white/40 hover:text-fg"}`} data-id="element-975" data-mp="5qvpnidh6ugt">
              {f}
            </button>)}
        </div>
        <motion.ul layout className="auto-grid" style={{
        "--min": "340px"
      } as React.CSSProperties} data-id="element-976" data-mp="2bn9goeyyzvgk">
          <AnimatePresence mode="popLayout" data-id="element-977" data-mp="fk4rl5zc1r9p">
            {visible.map(p => <motion.li layout key={p.slug} initial={{
            opacity: 0,
            scale: 0.97
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.97
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full" data-id="element-978" data-mp="khd8z4cnpr9w">
                <WorkCard project={p} data-id="element-979" data-mp="13ffuh95zx62y" />
              </motion.li>)}
          </AnimatePresence>
        </motion.ul>
        <p className="mt-8 text-muted" aria-live="polite" data-id="element-980" data-mp="1880gvpmkogwg">
          Showing {visible.length} {visible.length === 1 ? "project" : "projects"}
          {filter !== "All" ? ` in ${filter}` : ""}.
        </p>
      </section>
      <CtaBand source="work" title={<>Your project could be <span className="text-accent" data-id="element-982" data-mp="1m5p4v6bxs45q">next</span>.</>} data-id="element-981" data-mp="1h96zq5cp23sv" />
    </>;
}